import { useTranslation } from "react-i18next";
import {Chip, Tooltip} from "@mui/material";
import i18n from "i18next";
import {Consts} from "../pages/consts";
import {capitalizeFirstLetter} from "../pages/utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {useContext} from "react";
import InitContext from "../pages/InitContext";

const PatientGeneRow = ({ number,
                          gene,
                          handleDrugClick,
                          handleGeneDetails,
                          init,
                          printView = false,
                          onDeleteGene,
                          specified}) => {
  const { t } = useTranslation();
  const context = useContext(InitContext);
  const canDelete = (context?.role === Consts.PATIENT || context?.role === Consts.HCP_PRESCRIBER) && !printView;

  const getRiskSubstance = (risk) => {
    try {
      let substance = JSON.parse(risk?.recommendation)?.[i18n.language?.toUpperCase()]?.substanceName;

      if (substance === "") {
        substance = risk?.active_substance;
      }

      return i18n.language === "de" ? capitalizeFirstLetter(substance) : substance;
    } catch (e) {
      const fallback = risk?.active_substance || "";
      return i18n.language === "de" ? capitalizeFirstLetter(fallback) : fallback;
    }
  };

  const renderRisks = (risks, label) => (
    <>
      {risks.length > 0 && (
        <div className="patient-gene-row__risk-group">
          {label !== "" && (
            <label className="patient-gene-row__risk-group-title">{t(label)}:</label>
          )}
          <div className="patient-gene-row__risk-items">
          {risks?.map((risk, i) => {
            const substance = getRiskSubstance(risk);

            return (
              <button
                type="button"
                key={`risk${number}_${i}`}
                className={`patient-gene-row__risk-item ${printView ? "patient-gene-row__risk-item--static" : ""}`}
                onClick={() => handleDrugClick(risk, gene)}
                disabled={printView}
              >
                {substance}
              </button>
            )})
          }
          </div>
        </div>
      )}
    </>
  );

  const toolTipText = gene?.testDate && gene?.labName
    ? `${t("test_date")}: ${gene?.testDate}, ${t("laboratory_name")}: ${gene?.labName}`
    : "";

  return (
    <div className={`patient-gene-row ${printView ? "patient-gene-row--print" : ""}`}>
      <div className={`patient-gene-row__grid ${canDelete ? "patient-gene-row__grid--with-actions" : ""}`}>
        <div className="patient-gene-row__field patient-gene-row__field--gene">
          <div className="patient-gene-row__gene-mobile-row">
            <div className="patient-gene-row__field-label">{t("gene")}</div>
            <Tooltip title={toolTipText} placement="top" slotProps={{tooltip: {sx: {fontSize: '1.3rem'}}}}>
              <Chip
                value={gene}
                label={<label className={(init ||!specified) ? "chip-label_link" : "chip-label"}>{gene?.geneName}</label>}
                sx={{
                  backgroundColor: specified ? "#1565a0" : "#d32f2f",
                  color: "#fff",
                  margin: "0",
                  cursor: specified ? "pointer" : "default",
              }}
                onClick={() => handleGeneDetails(gene)}
              />
            </Tooltip>
            {canDelete && (
              <button
                type="button"
                onClick={ () => onDeleteGene(gene) }
                className="symptom-ui-button symptom-ui-button--icon symptom-ui-button--danger patient-gene-row__delete-button patient-gene-row__delete-button--mobile"
                aria-label={t("delete", { defaultValue: "Delete" })}
              >
                <FontAwesomeIcon icon={ faTrash }/>
              </button>
            )}
          </div>
        </div>

        <div className="patient-gene-row__field">
          <div className="patient-gene-row__field-label">{t("genotype")}</div>
          <label className="patient-gene-row__field-value">{gene?.genotype || t(Consts.NOT_SPECIFIED)}</label>
        </div>

        <div className="patient-gene-row__field">
          <div className="patient-gene-row__field-label">{t("phenotype")}</div>
          <label className="patient-gene-row__field-value">{gene?.phenotype ? t(gene.phenotype) : t(Consts.NOT_SPECIFIED)}</label>
        </div>

        <div className="patient-gene-row__field patient-gene-row__field--recommendations">
          <div className="patient-gene-row__field-label">{t("critical_medicines_and_recommendations")}</div>
          <div className="patient-gene-row__recommendations">
            {renderRisks(gene?.phenoRisks || [], "phenotype_related")}
            {renderRisks(gene?.genoRisks || [], "genotype_related")}
            {renderRisks(gene?.risks || [], "")}
            {(!gene?.risks?.length && !gene?.phenoRisks?.length && !gene?.genoRisks?.length) &&
              <div className="patient-gene-row__empty-state"><label>{t("not_found")}</label></div>
            }
          </div>
        </div>

        { canDelete &&
          <div className="patient-gene-row__actions">
          <button
            type="button"
            onClick={ () => onDeleteGene(gene) }
            className="symptom-ui-button symptom-ui-button--icon symptom-ui-button--danger patient-gene-row__delete-button"
            aria-label={t("delete", { defaultValue: "Delete" })}
          >
            <FontAwesomeIcon icon={ faTrash }/>
          </button>
          </div>
        }
      </div>
    </div>
  );
};

export default PatientGeneRow;
